import { render } from "./FloatHumorSelect.vue?vue&type=template&id=14222e6b"
import script from "./FloatHumorSelect.vue?vue&type=script&lang=js"
export * from "./FloatHumorSelect.vue?vue&type=script&lang=js"

import "./FloatHumorSelect.vue?vue&type=style&index=0&id=14222e6b&lang=css"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__